<template>
    <el-header style="padding-left: 0">
        <div style="display: flex; align-items: center">
            <div class="logo" style="width: 179px; height: 49px">
                <p><el-image :src="imgUrl"></el-image></p>
            </div>
            <p style="font-size: 22px; padding-left: 32px">商家后台</p>
        </div>
        <div class="right">
            <div class="badge">
                <el-badge :value="getUnreadCount" :hidden="getUnreadCount == 0" class="item">
                    <i class="el-icon-bell" @click="goMessage"></i>
                </el-badge>
            </div>

            <div class="admin">
                <div class="userImg">
                    <img src="https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100" />
                </div>
                <el-dropdown @command="dropDownClick">
                    <span class="el-dropdown-link">
                        <p v-if="$store.state.userInfo">
                          {{$store.state.userInfo.company_name}}
                           <!--  {{ !!$store.state.userInfo.identity_number ? $store.state.userInfo.real_name : $store.state.userInfo.company_name }} -->
                        </p>
                        <!--  -->
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="exit">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="back"></div>
        </div>
    </el-header>
</template>
<script>
import "@/assets/img/logo.png";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    name: "sHead",
    data() {
        return {
            imgUrl: require("@/assets/img/logo.png"),
        };
    },
    computed: {
        ...mapGetters({
            isMenuColl: "getIsMenuColl",
            userInfo: "getUserInfo",
            getUnreadCount: "getUnreadCount",
        }),
    },
    mounted() {
      //console.log(this.$store.state.userInfo,'$store.state.userInfo')
    },
    methods: {
        ...mapMutations({
            setUserInfo: "setUserInfo", //设置用户信息
            setToken: "setToken", //设置token
            setLogin: "setLogin", //设置登陆状态
            setRegist: "setRegist",
        }),
        ...mapActions({
            outLogin: "product/outLogin",
        }),
        goMessage() {
            this.$router.push({ path: "/home/message" });
        },
        dropDownClick(command) {
            if (command == "exit") {
                this.outLogin({
                    token: this.$store.state.token,
                    cellphones: this.$store.state.userInfo.cellphone,
                    port: "merchant",
                }).then((res) => {
                    //  if(res.code==1){
                    //  }else{
                    //     this.$message.error(res.msg);
                    //  }
                });
                this.setUserInfo(null);
                this.setToken(null);
                this.setLogin(false);
                this.setRegist({ reviewer_status: "", phone: "" });
                this.$router.replace({ path: "/login" });
            }
        },
        meunCollClick() {
            this.$store.commit("setIsMenuColl", !this.isMenuColl);
        },
    },
};
</script>
<style lang="scss" scoped>
.el-header {
    height: 64px !important;
    width: 100%;
    background: #fff;
    color: #000000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgb(0, 21, 41, 0.1);
    .liu_warp {
        max-width: 92%;
        width: 100%;
        margin: 0 auto;
    }
    .menu_btn {
        margin-left: 10px;
        transform: translateY(2px);
        margin-right: auto;
        &:hover {
            cursor: pointer;
        }
        i {
            font-size: 20px;
        }
    }
    .logo {
        font-size: 24px;
        color: #fff;
        p {
            line-height: 48px;
            text-align: center;
        }
    }
    .right {
        display: flex;
        align-items: center;
        .badge {
            margin-right: 60px;
            cursor: pointer;
            i {
                font-size: 22px;
            }
        }
        .admin {
            display: flex;
            align-items: center;
            .userImg {
                width: 34px;
                height: 34px;
                &:hover {
                    transform: rotate(666turn);
                    transition-delay: 1s;
                    transition-property: all;
                    transition-duration: 59s;
                    transition-timing-function: cubic-bezier(0.34, 0, 0.84, 1);
                }
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 50%;
                    border: 1px solid #f6ca9d;
                    display: block;
                }
            }
            p {
                font-size: 14px;
                color: #000000;
                max-width: 300px;
                margin: 0 20px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                cursor: pointer;
            }
        }
        .back {
            i {
                font-size: 20px;
                color: #f6ca9d;
                margin-top: 12px;
                cursor: pointer;
            }
        }
    }
}
.logo {
    p {
        height: 100%;
        .el-image {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            ::v-deep .el-image__inner {
                height: 36px;
                width: auto;
            }
        }
    }
}
</style>